import backlinkApi from './backlinkNewApi';

export const backlinkReferralDomainApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getNumOfReferralDomainsPerMonth: build.query({
      query: body => ({
        url: '/api_backlink/v1/referral_domains/chart/num_of_referral_domains_per_month',
        method: 'POST',
        body: body
      })
    }),
    getReferralDomainsCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/referral_domains/',
        method: 'POST',
        body: body
      })
    }),
    getReferralDomainScoreDistribution: build.query({
      query: body => ({
        url: '/api_backlink/v1/referral_domains/chart/domain_score_distribution',
        method: 'POST',
        body: body
      })
    }),
    getReferralDomains: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/referral_domains/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useGetNumOfReferralDomainsPerMonthQuery,
  useGetReferralDomainsCountQuery,
  useGetReferralDomainScoreDistributionQuery,
  useGetReferralDomainsMutation
} = backlinkReferralDomainApi;
export default backlinkReferralDomainApi;
